import React from 'react';
import { theme } from 'components';
import { StyledBanner, StyledAffix, useTopElementHeight } from './utils';

const PartialBanner: React.FC = () => {
  const offsetTop = useTopElementHeight();

  return (
    <StyledAffix offsetTop={offsetTop}>
      <StyledBanner $color={theme.getColor('yellow1')}>
        Some components on this page are not available for the assumed user on
        the MLS Agent Plan.
      </StyledBanner>
    </StyledAffix>
  );
};

export default PartialBanner;
